<template>
  <div>
    <b-row class="text-center title-subsection mr-1 mt-2">
      <p>Pre-processing</p>
    </b-row>
    <b-container
      fluid
      class="w-100 m-0 p-0"
      @mouseover="onHover"
      @mouseleave="onLeave"
      @click="select()"
    >
      <b-row>
        <p
          v-if="preprocessingCntl.length>1"
          class="short-message"
        >
          Drag the elements to reorder
        </p>
        <draggable
          v-model="preprocessingCntl"
          v-bind="dragOptions"
          class="list-group w-100"
          @start="dragPreproc = true"
          @end="endDragPrep()"
        >
          <transition-group
            type="transition"
            :name="!dragPreproc ? 'flip-list' : null"
          >
            <b-container
              v-for="(element,index) in preprocessingCntl"
              :key="index+'Cont'"
              fluid
              class="w-100 ml-3 mr-0 my-0 p-0"
            >
              <b-row
                align-v="center"
                class="w-100"
              >
                <b-col class="m-0 p-0">
                  <MutiOptionsSelectionPreproc
                    :study="element"
                    :listelem="listPreProcessing"
                    :listcontr="preprocessingCntl"
                    @removeElement="removeElementPreproc"
                  />
                </b-col>
                <b-col
                  class="m-0 p-0"
                  cols="2"
                >
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="m-0 p-0"
                    @click="element.expanded=!element.expanded"
                  >
                    <b-icon
                      v-if="element.expanded"
                      aria-label="More"
                      icon="caret-up"
                    />
                    <b-icon
                      v-else
                      aria-label="More"
                      icon="caret-down"
                    />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="w-100">
                <b-collapse
                  v-model="element.expanded"
                  class="ml-5 mb-2 expanded-info p-1"
                >
                  <SelectedPreProc
                    :sectionconfig="sectionconfig"
                    :selectedvalue="element.valueSelection"
                  />
                </b-collapse>
              </b-row>
            </b-container>
          </transition-group>
        </draggable>
      </b-row>
      <b-row class="text-center my-1">
        <HoveredButton
          iconhover="plus-square"
          iconnohover="plus-square-fill"
          :isdisabled="preprocessingCntl.findIndex(ctrl=>ctrl.disabled)!==-1"
          :click-function="addPreprocesing"
        />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SelectedPreProc from './SelectedPreProc'
import MutiOptionsSelectionPreproc from '../MultiOptionsSelectionPreproc'
import {preprocesingMultiCtrl} from '@/assets/classes/multiOptionsCtllr.js'
import {hiddenConfCtrller} from '@/assets/classes/configuration.js'
import draggable from 'vuedraggable'
import HoveredButton from '../HoveredButton'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

export default {
  name: 'PreprocessingSelection',
  components:{
    SelectedPreProc,
    MutiOptionsSelectionPreproc,
    draggable,
    HoveredButton,
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    }
  },
  data() {
    return {
      elementsConfig:[],
      preprocessingCntl:[],
      dragPreproc: false,
      listPreProcessing:[],
      preprocessingCtrller: new hiddenConfCtrller(ConfigName.PreprocessingList,[]),
      routeContextHelp:'' //Route for the Context Help it depends on the Section
    }
  },
  computed:{
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      };
    }
  },
  mounted() {
    this.elementsConfig = [
      this.preprocessingCtrller
    ]
    this.preprocessingCtrller.value = this.listPreProcessing
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
    this.listPreProcessing = this.preprocessingCtrller.value
    this.initializeController()
    this.routeContextHelp=`ReportViewer/Studies/${this.sectionconfig}/Preprocessing`
  },
  methods: {
    ...mapActions([
      'setContextOnHover',
      'setContextFixElement',
      'setConfigReportModifiedReportViewer'
    ]),
   addPreprocesing(){
     preprocesingMultiCtrl.createNewPrepProc(this,this.listPreProcessing,this.preprocessingCntl) //Static function that add the new study in both arrays
     this.setConfigReportModifiedReportViewer()
   },
   initializeController(){ //Clear the controllers and initialize with the list of studies that comes from a higher level. It matches both lists
      this.preprocessingCntl = []
      this.listPreProcessing.forEach(preproc=>preprocesingMultiCtrl.recoverPrepProc(this,this.listPreProcessing,this.preprocessingCntl,preproc)) //Similar to Add study, but here it tries to recover the data
    },
    endDragPrep(){
      this.setConfigReportModifiedReportViewer()
      this.dragPreproc = false
      //Update the values in the array that is sent to the pre-processing
      this.listPreProcessing=[]
      this.preprocessingCntl.forEach(prepCntl=>this.listPreProcessing.push(prepCntl.valueSelection))
      this.preprocessingCtrller.setValue(this.listPreProcessing)
    },
    getElementsConfig(){
      return this.elementsConfig
    },
    onHover() {
      this.setContextOnHover(this.routeContextHelp)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
    select(){
      this.setContextFixElement(this.routeContextHelp)
    },
    removeElementPreproc(indexStudy, indexStudyCtrl){
      this.listPreProcessing.splice(indexStudy, 1);
      if(indexStudyCtrl >= 0)
        this.preprocessingCntl.splice(indexStudyCtrl, 1);
      this.preprocessingCntl.forEach(controller=>controller.updateOptions()) //Update all the options of the combobox
    }
  },
}
</script>

<style>
.short-message{
  font-weight: bold;
  font-size: 0.9rem;
}
</style>